require('./bootstrap/modal');

$('[data-toggle="modal"]').on('click', function (e) {
    e.preventDefault();
    console.log('here');
    let target = $(this).data('target');
    $(target).modal('show');
});

$('.modal .close').on('click', function () {
    // find iframe and pause it by swapping url with the same url without autoplay on
    let iframe = $(this).closest('.modal').find('iframe');
    if(iframe.length) {
        let iframeSrc = iframe.attr('src');
        iframe.attr('src', iframeSrc.replace('?autoplay=1', ''));
    }

    $(this).closest('.modal').modal('hide');
});

$(".modal").on('hidden.bs.modal', function () {
    // find iframe and pause it by swapping url with the same url without autoplay on
    let iframe = $(this).find('iframe');
    if(iframe.length) {
        let iframeSrc = iframe.attr('src');
        iframe.attr('src', iframeSrc.replace('?autoplay=1', ''));
    }
});
